<template>
  <div
    class="d-flex justify-center align-center flex-column"
    style="height: 100vh"
  >
    <div class="d-flex flex-column align-center">
      <v-img
        :src="require('@/assets/logo/logo-dark.svg')"
        width="40"
        height="40"
        contain
        class="mb-4"
      ></v-img>
      <h1>Payment Success</h1>

      <v-card
        class="pa-10 my-4 bg-smokeDark"
        width="500"
        variant="outlined"
        v-if="userProfile?.subscription?.plan"
      >
        <p style="font-weight: 400">
          <b>Congratulations!</b> You're now on the
          <b>{{ userProfile?.subscription?.plan }}</b> plan.
        </p>
        <p>
          You can now start using Stix to create your brand and generate
          content.
        </p>
      </v-card>
      <v-btn
        class="mt-4"
        color="primary"
        variant="flat"
        :loading="loading_subscription"
        @click="$router.push('/subscription')"
        >Continue</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAuth } from "firebase/auth";
export default {
  name: "PaymentSuccess",
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
    }),
  },
  data() {
    return {
      loading_subscription: false,
    };
  },
  async mounted() {
    this.loading_subscription = true;
    // Sleep for 3000ms
    const auth = getAuth();
    const user = auth.currentUser;
    await new Promise((resolve) => setTimeout(resolve, 5000));
    this.$store.dispatch("fetchUserProfile", user);
    this.loading_subscription = false;
  },
};
</script>
